// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__alert-change-status[data-v-313ab810]{color:red}", ""]);
// Exports
module.exports = exports;
